import { Component, OnInit, Input } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { MatDialog } from '@angular/material';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { McatalogConfigService } from 'src/app/services/catalogs-services/config-services/mcatalog-config.service';
import { ImageDialogComponent } from '../../shared-components/image-dialog/image-dialog.component';

@Component({
  selector: 'app-catalogs-config-photo-editor-card',
  templateUrl: './catalogs-config-photo-editor-card.component.html',
  styleUrls: ['./catalogs-config-photo-editor-card.component.scss']
})
export class CatalogsConfigPhotoEditorCardComponent implements OnInit {

  @Input() image;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;

  constructor(private spinnerService: SpinnerService,
              private dialog: MatDialog,
              private snackbarService: SnackBarService,
              private mcatalogConfigService: McatalogConfigService) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public updateMCatalogImage(imageUrl) {
    this.showSpinner = true;
    this.spinnerService.show('mcatalog-image-spinner');
    this.mcatalogConfigService.updateMCatalogBanner(imageUrl).subscribe(
      (res) => {
        this.showSpinner = false;
        this.spinnerService.hide('mcatalog-image-spinner');
        this.mcatalogConfigService.refreshMCatalogConfig();
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.showSpinner = false;
        this.spinnerService.hide('mcatalog-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('mcatalog-image-spinner');
    this.mcatalogConfigService.updateMCatalogBanner(null).subscribe(
      (res) => {
        this.showSpinner = false;
        this.spinnerService.hide('mcatalog-image-spinner');
        this.mcatalogConfigService.refreshMCatalogConfig();
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.showSpinner = false;
        this.spinnerService.hide('mcatalog-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.image, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.updateMCatalogImage(result[0].Url);
        }

      }
    );
  }
}
